// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".of_community .snackbar {\n    left: 10px;\n    transform: translatex(10px);\n}\n\n.snackbar > div {\n    background: #282525;\n}\n\n.snackbar .message {\n    display: flex;\n    align-items: center;\n}\n\n.snackbar .message > img {\n    width: 30px;\n    margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
